import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/style.scss';
import {Route,BrowserRouter as Router, Switch, Redirect} from "react-router-dom";
import {connect} from "react-redux";

import About from './pages/about/about'
import Navigation from './parts/Navbar';
import LandingPage from './pages/LandingPage';
import Event from './pages/Event/index';
import CompetitionUniv from './pages/CompetitionUniv/index';
import CompetitionSMA from './pages/CompetitionSMA/index';
import Workshop from './pages/Workshop';
import Footer from './parts/Footer';
import MerchLandingPage from './pages/Merch/MerchLandingPage';
import Register from './pages/Register/Register';
import SignIn from './pages/SignIn/SignIn';
import RegisterCompetitionPage from './pages/RegistEvent/RegisterCompetition';
import ChangePass from './pages/ChangePass/ChangePass';

import ProductPage from './pages/Merch/ProductPage';
import AllProduct from './pages/Merch/AllProduct';
import CheckoutPage from './pages/Merch/CheckoutPage';
import Account from 'pages/Account/Account';
import NotFound from 'pages/NotFound';
import ConfirmAccount from 'pages/ConfirmAccount/ConfirmAccount';
import RequestGetPassword from 'pages/RequestGetPassword/RequestGetPassword';
import ComingSoon from 'pages/ComingSoon';
import RegisterWorkshopContainer from 'pages/RegisWorkshop/RegisterWorkshop';
import SponsorPegadaian from 'pages/SponsorPage/SponsorPage';
import SponsorPeersona from 'pages/SponsorPage/SponsorPeersona';
import Seminar from 'pages/Seminar/Seminar';

import AdminSMAPage from 'pages/Admin/TeamSma';
import AdminUniPage from 'pages/Admin/TeamUni';


function hasLogIn(){
  return (
      <>
    <Route exact path = "/account" component={Account}/>
    <Route exact path = "/admin/univ" component={AdminUniPage}/>
    <Route exact path = "/admin/sma" component={AdminSMAPage}/>
    </>
  )
}

function notLogIn(){
  return(
    <>
      <Route path = "/register" component={Register}/>
      <Route exact path = "/signin" component={SignIn}/>
      <Route path = {`/account/confirm`} component={ConfirmAccount}/>
    </>
  )
}

const App =(props)  => {
  return (
    <>

    <Router>
      <Navigation/>
      <Switch>
        <Route path = "/about" component={About} />
        <Route path = "/event/competitionuniv" render={(p) => (
          <CompetitionUniv {... p} isLogIn = {props.isLogIn} />
        )}/>
        <Route path = "/event/competitionsma" render={(p) => (
          <CompetitionSMA {... p} isLogIn = {props.isLogIn} />
        )}/>
        <Route exact path = "/" render={(p) => (
          <LandingPage {... p} isLogIn={props.isLogIn} />
        )}/>
        <Route exact path = "/event/workshop" render={(p) => (
          <Workshop {... p} isLogIn = {props.isLogIn} />
        )}/>
        <Route exact path = "/sponsor" render={(p) => (
          <SponsorPegadaian {... p} isLogIn = {props.isLogIn} />
        )}/>
        <Route exact path = "/sponsor2" render={(p) => (
          <SponsorPeersona {... p} isLogIn = {props.isLogIn} />
        )}/>
        <Route path ="/event/seminar" component={Seminar}/>
        <Route path = {`/account/reset`} component={ChangePass}/>
        <Route path = "/account/changePass" component={RequestGetPassword} />

        {/* <Route exact path = "/merch" component={MerchLandingPage}/> */}

        {/* <Route exact path = "/event" component={Event}/> */}
        <Route path = "/event/competition/register">
        {props.isLogIn ?
          <RegisterCompetitionPage/> :
          <Redirect to="/signin" /> }
        </Route>

        <Route path = "/event/Workshop/register">
        {props.isLogIn ?
          <RegisterWorkshopContainer/> :
          <Redirect to="/signin" /> }
        </Route>

        {
          props.isLogIn ?
            hasLogIn() :
            notLogIn()
        }




        <Route component={NotFound}/>
      </Switch>

      <Footer/>

    </Router>

    </>
    // <div>
    //   <Navigation />
    //   <MerchLandingPage />
    // </div>
  );
}

const mapStateToProps = (state) =>{
  return{
      isLogIn : state.isLogIn,
      token   : state.token,
  }
}

export default connect(mapStateToProps)(App);
